import { InfiniteData } from "@tanstack/react-query";

function toInfiniteData<TData>(firstPage?: TData) {
  if (firstPage) {
    return {
      pages: [firstPage],
      pageParams: [null],
    };
  } else {
    return { pages: [], pageParams: [] };
  }
}

function flattenInfiniteData<TData, TOutput>(
  data: InfiniteData<TData> | undefined,
  selector: (input: TData) => TOutput[] | undefined,
): TOutput[] {
  if (!data) return [];
  return data.pages.flatMap((page) => selector(page) ?? []);
}

export { flattenInfiniteData, toInfiniteData };
